import type { MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import { getOrdersBasketNumberOfVisibleFieldsByProductDescription } from 'state/orders-basket/selectors';
import type { AppState } from 'state/state.model';
import { getOrdersBasketFormIdsByProductVariation } from 'state/workspaces/ordersBasket/tabContent/tabContent.selectors';

import type { OrdersBasketBodyOwnProps, OrdersBasketBodyStateProps } from './OrdersBasketBody.models';

const mapStateToProps: MapStateToProps<OrdersBasketBodyStateProps, OrdersBasketBodyOwnProps, AppState> = (
  state: AppState,
  ownProps: OrdersBasketBodyOwnProps,
) => ({
  formIds: getOrdersBasketFormIdsByProductVariation(state, {
    productSubType: ownProps.productSubType,
    productType: ownProps.productType,
  }),
  nbOfFields:
    getOrdersBasketNumberOfVisibleFieldsByProductDescription(state, {
      productSubType: ownProps.productSubType,
      productType: ownProps.productType,
    }) + 2,
});

export const connectOrdersBasketBodyComponent = connect(mapStateToProps);
